import React from "react";
import "./TableInfoHeader.scss";
import { Box, Typography } from "@mui/material";

function TableInfoHeaderAgent({ count, handleOpen, user }) {
  return (
    <Box className="table-info-header d-flex justify-content-between">
      <Typography 
        sx={{
          color: "#00365a",
          fontFamily: "Inter",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "30px",
        }}
      >
        Total: {count ? count : <>0</>} {user}
      </Typography>
      {/* <Box className="table-options">
        <Button onClick={handleOpen}>
          <Box>Zones</Box>
        </Button>
      </Box> */}
    </Box>
  );
}

export default TableInfoHeaderAgent;
